export default {
  computed: {
    shiftIsStarted () {
      return this.$store.state.shift.isStarted
    }
  }
}
